export default (activePlan, subscriptionStatus, selectedPlan) => {
  let userPlan;

  if (selectedPlan === 'universityPlan') return 'premium';

  if (!activePlan || !subscriptionStatus) {
    userPlan = 'free';
  }

  if (activePlan && subscriptionStatus) {
    if (
      activePlan.name === 'single_basic_monthly' ||
      activePlan.name === 'single_basic_first14days'
    ) {
      userPlan = 'basic';
    } else if (
      activePlan.name === 'single_premium_monthly' ||
      activePlan.name === 'single_premium_threeMonth'
    ) {
      userPlan = 'premium';
    }
  }

  return userPlan;
};
